/* CUSTOM CODE */

// Scrolling Sticky
document.addEventListener('DOMContentLoaded', function() {
  const headerA = document.querySelector('header');
  headerA.classList.add('for-test');
});

// Slide Toggle for showing and hiding elements
Element.prototype.slideToggle = function(duration = 0, callback = null, isDown = false) {
  this.style.overflow = 'hidden';

  if (isDown) {
    this.style.display = 'block';
  }

  const elHeight = this.offsetHeight;
  const elPaddingTop = parseFloat(window.getComputedStyle(this).paddingTop);
  const elPaddingBottom = parseFloat(window.getComputedStyle(this).paddingBottom);
  const elMarginTop = parseFloat(window.getComputedStyle(this).marginTop);
  const elMarginBottom = parseFloat(window.getComputedStyle(this).marginBottom);

  const stepHeight = elHeight / duration;
  const stepPaddingTop = elPaddingTop / duration;
  const stepPaddingBottom = elPaddingBottom / duration;
  const stepMarginTop = elMarginTop / duration;
  const stepMarginBottom = elMarginBottom / duration;

  let start;

  const step = (timestamp) => {
    if (start === undefined) start = timestamp;

    const elapsed = timestamp - start;

    if (isDown) {
      this.style.height = `${stepHeight * elapsed}px`;
      this.style.paddingTop = `${stepPaddingTop * elapsed}px`;
      this.style.paddingBottom = `${stepPaddingBottom * elapsed}px`;
      this.style.marginTop = `${stepMarginTop * elapsed}px`;
      this.style.marginBottom = `${stepMarginBottom * elapsed}px`;
    } else {
      this.style.height = `${elHeight - stepHeight * elapsed}px`;
      this.style.paddingTop = `${elPaddingTop - stepPaddingTop * elapsed}px`;
      this.style.paddingBottom = `${elPaddingBottom - stepPaddingBottom * elapsed}px`;
      this.style.marginTop = `${elMarginTop - stepMarginTop * elapsed}px`;
      this.style.marginBottom = `${elMarginBottom - stepMarginBottom * elapsed}px`;
    }

    if (elapsed >= duration) {
      this.style.height = '';
      this.style.paddingTop = '';
      this.style.paddingBottom = '';
      this.style.marginTop = '';
      this.style.marginBottom = '';
      this.style.overflow = '';

      if (!isDown) {
        this.style.display = 'none';
      }

      if (typeof callback === 'function') {
        callback();
      }
    } else {
      window.requestAnimationFrame(step);
    }
  };

  window.requestAnimationFrame(step);
};

Element.prototype.slideUp = function(duration, callback) {
  this.slideToggle(duration, callback);
};

Element.prototype.slideDown = function(duration, callback) {
  this.slideToggle(duration, callback, true);
};

// Mobile Menu Logic
const overlays = document.querySelectorAll('.the-overlay');
const body = document.querySelector('body');
const menuBtn = document.querySelector('.menu-btn');
const menuItems = document.querySelector('.menu-items');
const liElems = document.querySelectorAll('.menu-items li');

// Add expand functionality to dropdowns
liElems.forEach((elem) => {
  const childrenElems = elem.querySelectorAll('.dropdown-menu, .submenu');
  if (childrenElems.length > 0) {
    elem.firstElementChild.classList.add('expand-btn');
    elem.classList.add('dropdown');
  }
});

function toggle() {
  menuBtn.classList.toggle('open');
  menuItems.classList.toggle('open');
  body.classList.toggle('the-overflow');
  overlays.forEach(overlay => overlay.classList.toggle('overlay--active'));

  const firstExpandButton = document.querySelector('.menu-item.expand-btn');
  if (firstExpandButton) {
    if (menuBtn.classList.contains('open')) {
      // firstExpandButton.classList.add('open');  
      // firstExpandButton.nextElementSibling.slideDown(200);

       // If menu is open, hide the element on mobile
       const style = document.createElement('style');
       style.innerHTML = `
         @media (max-width: 1024px) {
           .kl-teaser-RwE72Y {
             display: none !important;
           }
         }
       `;
       document.head.appendChild(style);
    } else {
      // firstExpandButton.classList.remove('open');
      // firstExpandButton.nextElementSibling.slideUp(200);

       // If menu is not open, show the element on mobile
       const style = document.createElement('style');
       style.innerHTML = `
         @media (max-width: 1024px) {
           .kl-teaser-RwE72Y {
             display: block !important;
           }
         }
       `;
       document.head.appendChild(style);
    }
  }

   // Prevent body scrolling when the menu is open
   if (menuBtn.classList.contains('open')) {
    // Disable body scrolling when the menu is open
    body.style.overflow = 'hidden';
  } else {
    // Enable body scrolling when the menu is closed
    body.style.overflow = '';
  }

  setTimeout(() => {}, 10);
}

document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape' && menuItems.classList.contains('open')) {
    toggle();
  }
});

document.addEventListener('click', function(e) {
  const target = e.target;
  const isMenu = target.closest('.menu-items');
  const isHamburger = target === menuBtn;

  if (!isMenu && !isHamburger && menuItems.classList.contains('open')) {
    toggle();
  }
});

menuBtn.addEventListener('click', function(e) {
  e.stopPropagation();
  toggle();
});

// Mobile menu expand logic
document.querySelectorAll('.expand-btn').forEach((btn) => {
  btn.classList.remove('open');
  btn.addEventListener('click', (ebb) => {
    if (window.innerWidth <= 1024) {
      ebb.preventDefault();
      closeAllDropdownsExcept(btn);
      const nextElement = btn.nextElementSibling;
      btn.classList.toggle('open');

      // Ensure we remove the 'added-class' from all other .dropdown-menu.mega-menu elements
      document.querySelectorAll('.dropdown-menu.mega-menu').forEach((dropdownMenu) => {
        dropdownMenu.classList.remove('added-class');
      });

      // Add or toggle 'added-class' on the next dropdown menu
      if (nextElement && nextElement.classList.contains('dropdown-menu', 'mega-menu')) {
        nextElement.classList.toggle('added-class');
      }

      // Toggle the dropdown smoothly
      if (nextElement.style.display === 'none' || !nextElement.style.display) {
        nextElement.slideDown(100);
      } else {
        nextElement.slideUp(100);
      }

       // Scroll the .menu-items container into view when the dropdown is clicked
       if (btn.classList.contains('open')) {
        scrollMenuItemsIntoView();
      }

      setTimeout(() => {}, 10);
    }
  });
});

function closeAllDropdownsExcept(currentBtn) {
  document.querySelectorAll('.expand-btn').forEach(function (btn) {
    if (btn !== currentBtn && btn.classList.contains('open')) {
      btn.classList.remove('open');
      btn.nextElementSibling.slideUp(100);
    }
  });
}

window.addEventListener('resize', () => {
  if (window.innerWidth > 1024) {
    if (menuBtn.classList.contains('open')) {
      toggle();
    }
    document.querySelectorAll('.expand-btn').forEach(btn => btn.classList.remove('open'));
    document.querySelectorAll('.menu-items .dropdown-menu, .submenu').forEach(menu => menu.style.display = '');
  }
});

// Function to scroll the .menu-items container into view
function scrollMenuItemsIntoView() {
  let menuItemsContainer = document.querySelector('.menu-items.menu-items-spec.open'); // Target the .menu-items container with 'open' class

  if (menuItemsContainer) {
    // Get the height of the viewport
    const viewportHeight = window.innerHeight;

    // Get the position of the .menu-items container in relation to its parent container
    const elementPosition = menuItemsContainer.getBoundingClientRect().top;

    // Get the height of the dropdown menu (`dropdown-menu mega-menu`) if it's present
    const dropdownMenu = document.querySelector('.dropdown-menu.mega-menu.added-class'); // Get the next dropdown menu
    const dropdownHeight = dropdownMenu ? dropdownMenu.offsetHeight : 0; // If there's no dropdown, height is 0 
 
    // Calculate the target scroll position to make the element 30% from the top of the viewport
    const targetScrollPosition = elementPosition + window.scrollY - ((viewportHeight + dropdownHeight) * 0.90);

    // Scroll the .menu-items container into view with smooth scrolling
    menuItemsContainer.scrollTo({
      top: targetScrollPosition
    });

    // Debugging logs to check if the calculations are correct
    console.log("viewportHeight: ", viewportHeight);
    console.log("elementPosition: ", elementPosition);
    console.log("dropdownHeight: ", dropdownHeight);
    console.log("targetScrollPosition: ", targetScrollPosition);
  }
}


// Smooth scrolling on anchor click
document.querySelectorAll('a[href*="#"]').forEach((element) => {
  element.addEventListener('click', function(e) {
    const href = this.getAttribute('href');
    const targetId = href.split('#')[1];
    const target = document.getElementById(targetId);

    if (target) {
      const targetRect = target.getBoundingClientRect();
      const offsetTop = targetRect.top + window.pageYOffset - 180;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });

      if (targetId) {
        e.preventDefault();
      }
    }
  });
});

// Ensure mobile submenus open correctly without causing layout issues
document.addEventListener("DOMContentLoaded", function() {
  const detailsElements = document.querySelectorAll('details[id^="Details-HeaderSubMenu-"]');
  detailsElements.forEach(function(details) {
    details.setAttribute('open', 'true');
  });
});
